import { Resource } from 'ia-react-core';
import React, { FC } from 'react';
import { InformativeMessageDto } from '../interfaces/InformativeMessageDto';
import transformInformativeMessageData from './transformInformativeMessageData';
import getSitecorePath from '../../../utils/getSitecorePath';

export interface InformativeMessageResourceProps {
}

const InformativeMessageResource: FC<InformativeMessageResourceProps> = () => {
  const sitecorePath = getSitecorePath('login/authentication-informative-message-full', false, '/api/ssc/aggregate/content/Items/authentication-informative-message-full/');
  return (
    <Resource
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      transformResponse={(dto: InformativeMessageDto) => transformInformativeMessageData(dto)}
      name="SiteCoreInformativeMessageResource"
      url={sitecorePath}
      dataDst="SiteCoreInformativeMessage"
      requestOnLanguageChange
      autoRequest
    />
  );
};

export default InformativeMessageResource;
